import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Tag as AntTag } from 'antd';
import styled from 'styled-components';
import chroma from 'chroma-js';
var Tag = styled(AntTag).withConfig({
  shouldForwardProp: function shouldForwardProp(props) {
    return !['solid', 'bordered'].includes(props);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n&.ant-tag{\n  background-color: ", ";\n  border: ", ";\n  color: ", ";\n}\n"])), function (props) {
  return props.solid ? chroma(props.theme.colors[props.color] || props.theme.colors.primary).alpha(0.1).hex() : 'transparent';
}, function (props) {
  return props.bordered ? "".concat(props.theme.colors[props.color] || props.theme.colors.primary, " solid 1px") : 'none';
}, function (props) {
  return chroma(props.theme.colors[props.color] || props.theme.colors.primary).darken(0.5).hex();
});
Tag.defaultProps = {
  color: 'primary',
  solid: true,
  bordered: false
};
export default Tag;